


























































































































































































































































































































































































































































interface NavList {
    name: string;
    dataList: string;
}
interface subjectVal {
    currSymbol: string | null;
    measuringUnit: string | null;
    id: number | null;
}
import { Component, Vue, Prop } from "vue-property-decorator";
import ChooseSubjectVue from "../ChooseSubject.vue";
import { mapGetters } from "vuex";
import NumCurrencySubsidiaryVue from "../SubsidiaryLedger/NumCurrencySubsidiary.vue";
import version from "@/version";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "num-currency-subsidiary": NumCurrencySubsidiaryVue
    }
})
export default class CurrencyAndSumDialog extends Vue {
    @Prop({ type: String })
    yearMonth?: string;

    @Prop({ type: String })
    startPeriod?: string;

    @Prop({ type: String })
    endPeriod?: string;

    @Prop({ type: String })
    dialogStatusNum?: string;

    @Prop({ type: String })
    dialogTitle?: string;

    @Prop({ type: Object })
    searchData?: any;

    tableData: Balance.Balance[] = [];
    showDetailNum: boolean = false;

    mounted() {
        this.fetchData();
        console.log(this.searchData)
    }

    syncScroll() {
		const tbody = this.$el.querySelector(".data-table")!;
		this.$el.querySelectorAll(".col-fixed")!.forEach(td => {
            (<HTMLElement>td).style.transform = `translateX(${tbody.scrollLeft}px)`;
        });
    }

    // 获取表格数据
    fetchData() {
        console.log(this.searchData.endLevel)
        Vue.axios
            .post(`balances/find`, {
                accountBookId: this.$store.state.accountBook.id,
                startPeriod: this.startPeriod,
                endPeriod: this.endPeriod,
                buttonStatus: this.dialogStatusNum,
                isBNLJ: this.searchData.balContentNowYear ? 1 : 0,
                startSubjectNo: this.searchData.startSubjectNo === null ? null : this.searchData.startSubjectNo.no,
				endSubjectNo: this.searchData.startSubjectNo === null ? null : this.searchData.startSubjectNo.no,
				minLevel: this.searchData.minLevel,
				maxLevel: this.searchData.maxLevel,
				isShowDim: this.searchData.isShowDim ? 1 : 0,
				isHideZeroEnd: this.searchData.isHideZeroEnd ? 1 : 0,
				isHideZeroFs: this.searchData.isHideZeroFs ? 1 : 0,
            })
            .then(res => {
                this.tableData = res.data.balances;
            });
    }

    // 打开明细账
    subTableData: Subject.Subject[] = [];
    subjectVal: subjectVal = {
        currSymbol: null,
        measuringUnit: null,
        id: null,
    };
    openSubsidiary(data: Balance.Balance) {
        this.subjectVal.currSymbol = data.currSymbol;
        this.subjectVal.measuringUnit = data.measuringUnit;
        this.subjectVal.id = data.subjectId;
        console.log(data)
        Vue.axios
            .post(`details/find`, {
                accountBookId: this.$store.state.accountBook.id,
                startPeriod: this.startPeriod,
                endPeriod: this.endPeriod,
                assistingAccountId: null,
                relation: data.relation,
                subjectId: data.subjectId
            })
            .then(res => {
                this.subTableData = res.data.subsidiarys;
                this.showDetailNum = true;
            });
    }
    closeDetailNum() {
        this.showDetailNum = false;
    }
    // 打印
    url: string = ""
    pageDownload() {
        if (this.dialogTitle === "数量金额余额表") this.url = `${Vue.axios.defaults.baseURL}export/pdf/balance/num?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.startPeriod}&endPeriod=${this.endPeriod}&version=${version}&token=${this.$store.state.account.token}`;
        else if (this.dialogTitle === "外币金额余额表") this.url = `${Vue.axios.defaults.baseURL}export/pdf/balance/curr?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.startPeriod}&endPeriod=${this.endPeriod}&version=${version}&token=${this.$store.state.account.token}`;
        else if (this.dialogTitle === "数量外币余额表") this.url = `${Vue.axios.defaults.baseURL}export/pdf/balance/numcurr?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.startPeriod}&endPeriod=${this.endPeriod}&version=${version}&token=${this.$store.state.account.token}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", this.url);
    }
    mainDownload() {
        if (this.dialogTitle === "数量金额余额表") this.url = `${Vue.axios.defaults.baseURL}export/balance/num?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.startPeriod}&endPeriod=${this.endPeriod}&version=${version}&token=${this.$store.state.account.token}`;
        else if (this.dialogTitle === "外币金额余额表") this.url = `${Vue.axios.defaults.baseURL}export/balance/curr?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.startPeriod}&endPeriod=${this.endPeriod}&version=${version}&token=${this.$store.state.account.token}`;
        else if (this.dialogTitle === "数量外币余额表") this.url = `${Vue.axios.defaults.baseURL}export/balance/numcurr?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${this.startPeriod}&endPeriod=${this.endPeriod}&version=${version}&token=${this.$store.state.account.token}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", this.url);
    }
}
